// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_2RpN7","iconButtonWrapper":"_2RpN7","number":"_2g4l4"};